"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.swrConfig = exports.errorHandlingSwrOptions = exports.basicSwrOptions = exports.API_TIMEOUT = exports.API_SESSION_ERROR = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _reloadShoppingContext = require("../utils/reloadShoppingContext");
const API_TIMEOUT = exports.API_TIMEOUT = 10000;
const API_SESSION_ERROR = exports.API_SESSION_ERROR = 'No shopping session for specified sessionId';
const basicSwrOptions = exports.basicSwrOptions = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false
};
const errorHandlingSwrOptions = exports.errorHandlingSwrOptions = {
    ...basicSwrOptions,
    onError: (error)=>{
        var _error_response;
        (0, _checkoutUtils.showErrorNotification)();
        if (error instanceof _globalApiClientReact.AxiosError && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === _globalApiClientReact.HttpStatusCodes.status404NotFound) {
            var _error_response_data;
            const errorResponseData = (_error_response_data = error.response.data) !== null && _error_response_data !== void 0 ? _error_response_data : {};
            const { message, Message } = errorResponseData;
            var _ref;
            const usedMessage = (_ref = message !== null && message !== void 0 ? message : Message) !== null && _ref !== void 0 ? _ref : '';
            if (usedMessage.includes(API_SESSION_ERROR)) {
                // try to refresh current shopping context, thus receiving current shopping session etc.
                (0, _reloadShoppingContext.reloadShoppingContext)();
            }
        }
    }
};
const swrConfig = exports.swrConfig = {
    focusThrottleInterval: 300000,
    suspense: false,
    ...basicSwrOptions
};
